import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsItemForm from '../../../components/forms/NewsItemForm';
import { useNewsItemApi } from '../../../hooks/useNewsItemApi';
import { useNavigate } from 'react-router-dom';
import { NewsItemDTO } from '../../../services/apiClient';

const NewsItemCreate: React.FC = () => {
  const { create, isLoading } = useNewsItemApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'News Items', href: '/admin/newsitems' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: NewsItemDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/newsitems');
    } catch (error) {
      console.error('Error creating NewsItem:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newsitems"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.NewsItem.Edit'
    >
      <NewsItemForm
        initialValues={{} as NewsItemDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/newsitems')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default NewsItemCreate;